export type Environment = 'development' | 'staging' | 'production';

export interface EnvironmentConfig {
  apiBaseUrl: string;
  environment: Environment;
}

const getEnvironment = (): Environment => {
  // Check for explicit environment variable
  if (process.env.REACT_APP_ENVIRONMENT) {
    return process.env.REACT_APP_ENVIRONMENT as Environment;
  }

  // Auto-detect based on hostname
  const hostname = window.location.hostname;
  
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return 'development';
  }
  
  if (hostname.includes('staging') || hostname.includes('stg')) {
    return 'staging';
  }
  
  // Default to production for any other domain
  return 'production';
};

const getApiBaseUrl = (env: Environment): string => {
  // First check for explicit API URL override
  if (process.env.REACT_APP_API_BASE_URL) {
    return process.env.REACT_APP_API_BASE_URL;
  }

  // Auto-determine based on environment
  switch (env) {
    case 'development':
      return 'http://localhost:8000';
    case 'staging':
      return 'https://your-staging-api.com';
    case 'production':
      // Same site as the app, so the session cookie is first-party. The
      // run.app address serves the same thing but is cross-site, which costs
      // Safari users their session on every reload.
      return 'https://api.kintsuba.ai';
    default:
      return 'http://localhost:8000';
  }
};

export const getEnvironmentConfig = (): EnvironmentConfig => {
  const environment = getEnvironment();
  const apiBaseUrl = getApiBaseUrl(environment);

  return {
    environment,
    apiBaseUrl,
  };
};

export const config = getEnvironmentConfig();